import HomeModal from './HomeModal';

export default HomeModal;
